export default __webpack_public_path__ + "static/media/Group 484.b9be53ad.png";